import BaseCustomControl from 'components/Map/Controls/CustomControls/BaseCustomControl';
import React from 'react';

interface Props {
	title?: string;
	handleClick?: () => void;
	active?: boolean;
}

const AvalancheTerrainControl: React.FC<Props> = ({
	title,
	handleClick,
	active = false,
}) => {
	function toggleAvalancheTerrain() {}

	return (
		<BaseCustomControl
			icon="avalancheTerrain"
			title={title}
			handleControl={handleClick ?? toggleAvalancheTerrain}
			className="ol-avalanche-terrain"
			labelPosition="left"
			active={active}
		/>
	);
};

export default AvalancheTerrainControl;
